import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Company } from "@modules/companies/types";
import { CompanyFormValues } from "@modules/companies/validations";
import { editCompanyService } from "./service";
import { UseEditCompanyMutationOptions } from "./types";
import { listCompaniesQueryKey } from "../../queries/listCompanies/query";

export function useEditCompanyMutation(
  id: string,
  options?: UseEditCompanyMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();
  const queryClient = useQueryClient();

  return useMutation<Company, ApiError, Partial<CompanyFormValues>>({
    mutationFn: (data) => editCompanyService(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listCompaniesQueryKey,
        refetchType: "all",
      });

      open?.({
        type: "success",
        message: translate("v1/company_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
